<template>
  <div class="regulate-program g-button-modal">
    <h3 class="title--subtitle">
      Program Control
    </h3>
    <div class="two-columns">
      <div class="two-columns__column">
        <button
          v-if="HasPausedEntries"
          class="g-btn g-btn--rounded wide"
          @click="Click('Resume')"
        >
          Resume
        </button>
        <button
          v-else
          class="g-btn g-btn--rounded wide"
          @click="Click('Pause')"
        >
          <font-awesome-icon :icon="['fas', 'pause']" /> Pause
        </button>
      </div>
      <div class="two-columns__column">
        <button
          class="g-btn g-btn--rounded wide"
          @click="Click('Stop')"
        >
          <font-awesome-icon :icon="['fas', 'stop']" /> Stop
        </button>
      </div>
    </div>
    <slot v-if="!ModalData.entryState">
      <hr>
      <h3 class="title--subtitle">
        Start New Run
      </h3>
      <div class="two-columns">
        <div class="two-columns__column">
          <button
            class="g-btn g-btn--rounded wide"
            @click="Click('Start new')"
          >
            <font-awesome-icon :icon="['fas', 'play']" /> <span>Start New</span>
          </button>
        </div>
        <div class="two-columns__column">
          <button
            class="g-btn g-btn--rounded wide disabled"
            disabled
            @click="Click('Start step')"
          >
            <font-awesome-icon :icon="['fas', 'play']" /> <span>Start Step</span>
          </button>
        </div>
      </div>
    </slot>
    <slot v-else>
      <hr>
      <ol>
        <li>
          <h3 class="title title--subtitle">
            Connected Stations
          </h3>
          <station-component
            class="ignore-g-styles"
            :store="store"
            :modal-data = "ModalData"
            v-bind="{type:'program-station', Data: StationInformation}"
            @SetPageMessage = "SetPageMessage"
          />
        </li>
      </ol>
    </slot>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import StationComponent from '@/components/StationComponent'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'RegulateProgram',
  components: {
    'station-component': StationComponent,
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      defaultStation: {'duration': '',  'handleID': '', 'id': '', 'name': '', 'remainTime': '0', 'runningMode': ''}
    }
  },
  computed: {
    HasPausedEntries() {
      return this.ModalData.data.runningEntries.filter((entry) => entry.runningMode === 'Paused').length
    },
    StationInformation() {
      if(this.ModalData.selSt.SelectedData === '') {
        return this.defaultStation
      } else {
        const id = this.ModalData.selSt.SelectedData.id.slice(1)
        return this.store.getData('stations').filter((station) => station.StId === id)[0]
      }
    },
  },
  methods: {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
      this.$emit('CloseModal')
    },
    Click(command) {
      this.$emit('SetPageMessage', {
        target: 'ProgramComponent',
        command: command,
        data: this.ModalData.data.ID,
        entry: this.ModalData.entry
      })
      this.$emit('CloseModal')
    }
  }
}
</script>

<style lang="scss">
  /*All styles comes from global-styles*/

  .regulate-program {
    box-sizing: border-box;
    padding: 30px;

    &.g-button-modal {
      display: inline-block;
      max-width: 400px;
    }

    .title--subtitle:first-child {
      margin-top: 0;
    }
    .two-columns {
      padding: 0 50px;
      width: auto !important;

      .g-btn {
        white-space: nowrap;
        width: 100%;
        pading: 10px;

        * {
          /* do it for the children! */
        }
      }
    }

    hr {
      margin: 30px 0px;
    }

    .station {
      float: none;
    }
  }
</style>
